import React from 'react';
import styled from '@emotion/styled';
import { device } from './device';
import { connect } from 'react-redux';
import _get from 'lodash.get';
import { StyledContainer } from './Container';
import css from '@emotion/css';


interface IStyledFaq {
    theme: { [key: string]: any };
    type?: string;
    usertype?: string;
}
interface IFaqdata {
    faqData?: { [key: string]: any };
    usertype?: string
}
const ToiPrintFaq = (props: IFaqdata) => {
    const { faqData, usertype } = props;
    if (!faqData) {
        return null;
    }
    return (
        <StyledContainer layout={'faq'} usertype={usertype} >
            {faqData?.h1 ? <Title>{faqData?.h1}</Title> : null}
            {Array.isArray(faqData?.qna) && faqData.qna.length ?
                <FaqContainer usertype={usertype}>
                    {faqData.qna.map((item: { [key: string]: any }) => {
                        return (
                            <>
                                <FaqHeading usertype={usertype}>{item.que}</FaqHeading>

                                {Array.isArray(item.ans) && item.ans.length ?
                                    (<FaqContent usertype={usertype}>
                                        {item.ans.map((val: string) => {
                                            return <Faqs usertype={usertype} dangerouslySetInnerHTML={{
                                                __html: val,
                                            }} />
                                        })}
                                    </FaqContent>) : null
                                }
                            </>
                        )
                    })}
                </FaqContainer> : null}
        </StyledContainer>
    )
}


const FaqContainer = styled.section<IStyledFaq>`
    background:  ${(props: IStyledFaq) => props.theme.faq.background}; 
    border: ${(props: IStyledFaq) => props.theme.faq.border}; 
    box-shadow: ${(props: IStyledFaq) => props.theme.faq.boxShadow}; 
    border-radius: ${(props: IStyledFaq) => props.theme.faq.borderRadius}; 
    padding: ${(props: IStyledFaq) => props.theme.faq.padding}; 
    @media screen and ${device.mobile},
    screen and (orientation: landscape) and (max-width: 1000px) {
        padding: ${(props: IStyledFaq) => props.theme.faq.mobilePadding};
        margin: ${(props: IStyledFaq) => props.theme.faq.mobileMargin};
    }
    ${(props: IStyledFaq) => props.usertype == "nonprime" && css`
        padding: ${props.theme.faq.mobilePadding};
    `}
`
const Title = styled.h2<IStyledFaq>`
    font-size: ${(props: IStyledFaq) => props.theme.faq.title.fontSize};
    font-weight: ${(props: IStyledFaq) => props.theme.faq.title.fontWeight};
    line-height: ${(props: IStyledFaq) => props.theme.faq.title.lineHeight};
    padding: ${(props: IStyledFaq) => props.theme.faq.title.margin};
    @media screen and ${device.mobile},
    screen and (orientation: landscape) and (max-width: 1000px) {
        font-size: ${(props: IStyledFaq) => props.theme.faq.title.mobileFontSize};
        line-height: ${(props: IStyledFaq) => props.theme.faq.title.mobileLineHeight};
        padding: ${(props: IStyledFaq) => props.theme.faq.title.mobileMargin};
    }
`
const FaqHeading = styled.h4<IStyledFaq>`
    font-size: ${(props: IStyledFaq) => props.theme.faq.heading.fontSize};
    font-weight: ${(props: IStyledFaq) => props.theme.faq.heading.fontWeight};    
    line-height: ${(props: IStyledFaq) => props.theme.faq.heading.lineHeight};
    @media screen and ${device.mobile},
    screen and (orientation: landscape) and (max-width: 1000px) {
        font-size: ${(props: IStyledFaq) => props.theme.faq.heading.nonPrimeFontSize};
        line-height: ${(props: IStyledFaq) => props.theme.faq.heading.mobileLineHeight}; 
    }
    ${(props: IStyledFaq) => props.usertype == "nonprime" && css`
        font-size: ${props.theme.faq.heading.mobileFontSize};
        line-height: ${props.theme.faq.heading.mobileLineHeight}; 
    `}
`
const FaqContent = styled.ul<IStyledFaq>`
    border-bottom:${(props: IStyledFaq) => props.theme.faq.content.border};
    padding: ${(props: IStyledFaq) => props.theme.faq.content.padding};
    margin: ${(props: IStyledFaq) => props.theme.faq.content.margin};
    &:last-child{
        border:0px;
        margin-bottom: 16px;
    } 
    @media screen and ${device.mobile},
    screen and (orientation: landscape) and (max-width: 1000px) {
        margin: ${(props: IStyledFaq) => props.theme.faq.content.mobileMargin};
        padding: ${(props: IStyledFaq) => props.theme.faq.content.mobilePadding};
        &:last-child{
            margin:0;
            padding: 0;
        } 
    }   
    ${(props: IStyledFaq) => props.usertype == "nonprime" && css`
        margin: ${props.theme.faq.content.mobileMargin};
        padding: ${props.theme.faq.content.mobilePadding};
    `}
`

const Faqs = styled.li<IStyledFaq>`
    font-size: ${(props: IStyledFaq) => props.theme.faq.list.fontSize};
    font-weight: ${(props: IStyledFaq) => props.theme.faq.list.fontWeight};
    line-height: ${(props: IStyledFaq) => props.theme.faq.list.lineHeight};
    list-style-type: ${(props: IStyledFaq) => props.theme.faq.list.disc};
    padding:${(props: IStyledFaq) => props.theme.faq.list.padding};
    color: ${(props: IStyledFaq) => props.theme.faq.list.color};
    span{
        font-weight: 600;
    }
    @media screen and ${device.mobile},
    screen and (orientation: landscape) and (max-width: 1000px) {
        font-size: ${(props: IStyledFaq) => props.theme.faq.list.mobileFontSize};
        line-height: ${(props: IStyledFaq) => props.theme.faq.list.mobileLineHeight};
        padding:${(props: IStyledFaq) => props.theme.faq.list.mobilePadding};
        margin:${(props: IStyledFaq) => props.theme.faq.list.mobileMargin};
    }
    ${(props: IStyledFaq) => props.usertype == "nonprime" && css`
        font-size: ${props.theme.faq.list.mobileFontSize};
        line-height: ${props.theme.faq.list.mobileLineHeight};
        padding:${props.theme.faq.list.mobilePadding};
        margin:${props.theme.faq.list.mobileMargin};
    `}
    
`

const mapStateToProps = (state: any) => ({
    faqData: _get(state?.translationConfig?.nudges?.printEdition, 'toiPrintFaqs', null),
});

export default connect(mapStateToProps, null)(ToiPrintFaq);